const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoustache(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.964844 5.84375 C 13.714844 5.78125 13.335938 6.746094 12.441406 6.746094 C 11.292969 6.746094 10.75 4.8125 8.953125 4.8125 C 7.53125 4.8125 7.097656 5.921875 7.003906 5.921875 C 6.90625 5.921875 6.472656 4.8125 5.050781 4.8125 C 3.253906 4.8125 2.710938 6.746094 1.5625 6.746094 C 0.667969 6.746094 0.289062 5.78125 0.0390625 5.84375 C -0.191406 5.902344 0.46875 9.1875 3.609375 9.1875 C 5.648438 9.1875 6.847656 7.601562 7.003906 7.601562 C 7.15625 7.601562 8.355469 9.1875 10.394531 9.1875 C 13.535156 9.1875 14.195312 5.902344 13.964844 5.84375 Z M 13.964844 5.84375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoustache);
export default __webpack_public_path__ + "static/media/moustache.178e2e811847c38c9a9e135a7e4481a1.svg";
export { ForwardRef as ReactComponent };